// @ts-nocheck
import { chain, DispatchCompleteAddProduct } from "@insite/client-framework/Store/Pages/QuickOrder/Handlers/AddProduct";
import { addToChainAfter, createChainHandler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const ExecuteOnSuccessCallback = createChainHandler("ExecuteOnSuccessCallback", chain, props => {
    (props.parameter as any).onSuccess?.();
});

addToChainAfter(chain, DispatchCompleteAddProduct, ExecuteOnSuccessCallback);
